/**
 * 旅行保险相关 API
 */
import { get, post } from './index';

// ==================== 产品相关 ====================

/**
 * 获取产品列表
 */
export const getProductList = () => {
  return get('/api/ibenterprise/public/open/v1/individual_product/product/list');
};

/**
 * 查询个险产品方案列表
 */
export const getPlanList = (productId) => {
  return get('/api/ibenterprise/public/open/v1/individual_product/plan/list', { productId });
};

/**
 * 根据方案ID查询保障责任列表
 */
export const getCoverageList = (planId) => {
  return get('/api/ibenterprise/public/open/v1/individual_product/coverage/list', { planId });
};

// ==================== 投保相关 ====================

/**
 * 个险保单提交接口
 */
export const submitOrder = (orderData) => {
  return post('/api/ibenterprise/public/open/v1/individual_order/submit', orderData);
};

/**
 * 上传文件接口
 */
export const productUploadFile = (fileType, file) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('fileType', fileType || 'excel');
  return post('/api/ibenterprise/public/open/v1/fileOpen/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

/**
 * 企业注册营业执照上传
 */
// export const uploadBusinessLicense = (file) => {
//   const formData = new FormData();
//   formData.append('file', file);
//   return post('/api/ibenterprise/broker/enterprise/v1/file/upload', formData);
// };

/**
 * 被保人数据导入接口
 */
export const importProductData = (path) => {
  return post('/api/ibenterprise/public/open/v1/individual_product/import_data', path);
};

// ==================== 保单相关 ====================

/**
 * 查询个险保单列表
 */
export const getPolicyList = (params) => {
  return post('/api/ibenterprise/broker/enterprise/v1/individual_policy_get/policyList', params);
};

/**
 * 查询个险订单列表（分页）
 */
export const getOrderList = (params) => {
  return post('/api/ibenterprise/broker/enterprise/v1/individual_order/get_page', params);
};

/**
 * 查询订单被保人列表（分页）
 * @param {Object} params - { orderId(必填), certNo, name, pageIndex, pageSize }
 */
export const getOrderInsuredList = (params) => {
  return post('/api/ibenterprise/broker/enterprise/v1/individual_order/get_insured_list', params);
};

/**
 * 导出个险订单列表
 */
export const exportOrder = (params) => {
  return post('/api/ibenterprise/broker/enterprise/v1/individual_order/export', params, {
    responseType: 'blob'
  });
};

/**
 * 订单被保人列表导出
 * @param {Object} params - { orderId(必填), certNo(选填), name(选填) }
 */
export const exportOrderInsuredList = (params) => {
  return post('/api/ibenterprise/broker/enterprise/v1/individual_order/export_insured_list', params, {
    responseType: 'blob'
  });
};

/**
 * 下载电子保单
 */
export const getElectronicPolicy = (id) => {
  return get('/api/ibenterprise/broker/enterprise/v1/individual_policy_get/electronicPolicyById', { id });
};

/**
 * 申请退保
 */
export const standardCancel = (id) => {
  return get('/api/ibenterprise/broker/enterprise/v1/individual_policy_get/standardCancel', { id });
};

/**
 * 查询保单人员列表
 */
export const getInsuredList = (params) => {
  return post('/api/ibenterprise/broker/enterprise/v1/individual_policy_get/getInsuredList', params);
};

/**
 * 导出保单人员列表
 */
export const exportInsuredList = (params) => {
  return post('/api/ibenterprise/broker/enterprise/v1/individual_policy_get/exportInsuredList', params, {
    responseType: 'blob'
  });
};

/**
 * 查询保单退保人员列表
 */
export const getCancelInsuredList = (params) => {
  return get('/api/ibenterprise/broker/enterprise/v1/individual_policy_get/getCancelInsuredList', params);
};

// ==================== 录屏相关 ====================

/**
 * 上传截图文件
 */
export const uploadScreenshot = (blob, fileName = 'screenshot.jpg') => {
  const formData = new FormData();
  formData.append('file', blob, fileName);
  return post('/api/monitor/file/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

/**
 * 提交录屏数据（录屏事件 + 截图链接）
 */
export const submitRecordingData = (data) => {
  return post('/app/api/recording/submit', data);
};

/**
 * 保存截图链接
 * @param {Object} data - { orderCode, screenshots }
 */
export const saveScreenshotLinks = (data) => {
  return post('/api/monitor/screenshot/saveScreenshots', data);
};

/**
 * 获取监控唯一编码
 * @param {string} orderCode - 订单编码
 */
export const getMonitorCode = (orderCode) => {
  return get('/api/monitor/detail/getMonitorCode', { orderCode });
};

/**
 * 保存录制内容（带唯一编码）
 * @param {Object} data - 录制数据
 */
export const saveMonitorDetail = (data) => {
  return post('/api/monitor/detail/save', data);
};

// ==================== 注册相关 ====================

/**
 * 企业客户注册
 */
export const cusRegister = (data) => {
  return post('/api/ibenterprise/public/open/v1/cusAuth/register', data);
};

/**
 * 企业客户登录
 */
export const cusLogin = (data) => {
  return post('/api/ibenterprise/public/open/v1/cusAuth/doLogin', data);
};

/**
 * 发送阿里云短信验证码
 */
export const getCaptchaCode = (cusName) => {
  return get(`/api/ibenterprise/public/open/v1/cusAuth/getCaptcha?cusName=${cusName}`);
};

// ==================== 行业类别 ====================



/**
 * 查询行业类别列表（一级/二级）
 * @param {number|string} fatherCode 父类 id，一级传 0，二级传选中一级的 id
 */
export const queryBusinessList = (fatherCode) => {
  return post(`/api/ibenterprise/public/open/v1/queryCustomerBusinessList?fatherCode=${fatherCode}`);
};

// 查询企业信息（需登录）
export const getEnterpriseInfo = (userId) => {
  return get(`/api/ibenterprise/broker/enterprise/v1/enterprise/getEnterpriseInfo?userId=${userId}`, {}, { requireAuth: true });
};

export default {
  getProductList,
  getPlanList,
  getCoverageList,
  submitOrder,
  productUploadFile,
  importProductData,
  getPolicyList,
  getOrderList,
  getOrderInsuredList,
  exportOrder,
  exportOrderInsuredList,
  getElectronicPolicy,
  standardCancel,
  getInsuredList,
  exportInsuredList,
  getCancelInsuredList,
  uploadScreenshot,
  submitRecordingData,
  saveScreenshotLinks,
  getMonitorCode,
  saveMonitorDetail,
  cusRegister,
  cusLogin,
  getCaptchaCode,
  queryBusinessList,
  getEnterpriseInfo
};
